import { Component, ElementRef, forwardRef, Inject, OnInit, Optional, PLATFORM_ID, ViewChild } from '@angular/core';
import { RecaptchaService } from './recaptcha.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { isPlatformBrowser } from '@angular/common';

export const RECAPTCHA_KEY = 'mtg-recaptcha-key';

@Component({
  selector: 'mtg-recaptcha',
  template: '',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RecaptchaComponent),
      multi: true
    }
  ]
})
export class RecaptchaComponent implements OnInit, ControlValueAccessor {
  private value: any;
  private _onTouchFunc: Function;
  private _onChangeFunc: Function;
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor(
    private recaptchaService: RecaptchaService,
    private elementRef: ElementRef,
    @Optional() @Inject(RECAPTCHA_KEY) private recaptchaKey: string,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }
    this.recaptchaService.load().subscribe(() => {
      (window as any).grecaptcha.render(this.elementRef.nativeElement, {
        sitekey: this.recaptchaKey,
        callback: this.callback.bind(this),
        size: window.innerWidth < 700 ? 'compact' : 'normal',
        theme: 'dark',
      });
    });
  }

  callback(value: any) {
    this.value = value;
    if (this._onTouchFunc) {
      this._onTouchFunc();
    }
    if (this._onChangeFunc) {
      this._onChangeFunc(value);
    }
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnTouched(fn: any): void {
    this._onTouchFunc = fn;
  }

  registerOnChange(fn: any): void {
    this._onChangeFunc = fn;
  }
}
